import { Component, Input, OnInit } from '@angular/core';
import { AdministratorService } from '@services/administrator/administrator.service';
import { UserAdminUI } from "@app/core/services/administrator/models/user-admin.model";
import { environment } from '@env/environment';
import { Observable } from 'rxjs';
import { PermissionEnum } from '../services/administrator/models/enum/permission.enum';

@Component({
    selector: 'app-menu',
    templateUrl: './menu.component.html',
    styleUrls: ['./menu.component.css'],
    standalone: false
})
export class MenuComponent implements OnInit {
  @Input() isToggle: boolean;

  Permissions = PermissionEnum;

  loggedAgent$: Observable<UserAdminUI>;
  menuicon = environment.application.menuicon;
  accessCreateUser = environment.access.createUser;

  constructor(private administratorService: AdministratorService) {
  }

  ngOnInit() {
    this.loggedAgent$ = this.administratorService.loggedAgent$;
  }
}
